import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { filter } from 'rxjs/operators';

import { PrivaLoaderComponent } from '@priva/components/loader';
import { PrivaNotificationComponent } from '@priva/components/notification';
import { PrivaSpinnerComponent } from '@priva/components/spinner';
import { PrivaLocalizationModule } from '@priva/localization';

import { ScannedCodeType } from 'app/features/scan-flow/models';
import { supportedBarcodeFormats } from 'app/features/scan-flow/utils/zxing-scanner.utils';

import { ScanQrStore } from './scan-qr.store';

@Component({
    selector: 'app-scan-qr',
    templateUrl: './scan-qr.component.html',
    styleUrl: './scan-qr.component.scss',
    imports: [
        AsyncPipe,
        PrivaLoaderComponent,
        PrivaNotificationComponent,
        PrivaSpinnerComponent,
        ZXingScannerModule,
        PrivaLocalizationModule,
    ],
    providers: [ScanQrStore],
})
export class ScanQrComponent {
    private componentStore = inject(ScanQrStore);
    private destroyRef = inject(DestroyRef);

    allowedCodeTypes = input<ScannedCodeType[]>([]);

    codeScanned = output<string>();
    scannerUnavailable = output<void>();

    cameraFound = false;
    scanNotification$ = this.componentStore.scanNotification$;
    scannerStarting = true;
    supportedBarcodeFormats = supportedBarcodeFormats;

    constructor() {
        this.componentStore.scannedCode$
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                filter((scannedCode) => scannedCode !== undefined),
            )
            .subscribe((scannedCode) => this.codeScanned.emit(scannedCode));
    }

    onCodeScanned(code: string) {
        this.componentStore.processScannedCode({
            allowedCodeTypes: this.allowedCodeTypes(),
            scannedCode: code,
        });
    }

    onScannerStarted() {
        this.scannerStarting = false;
        if (!this.cameraFound) this.scannerUnavailable.emit();
    }

    onCamerasFound() {
        this.cameraFound = true;
    }
}
